import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, filter, map } from 'rxjs/operators';

import { RootState } from '../reducers';
import { getSignedInUser } from '../selectors/auth.selectors';
import { Log } from '../utils/log';
import { navigate } from '../actions/core.actions';
import { RoutingPathResolver } from 'src/app/app-routing-path-resolver';
import { AuthGuard } from './auth.guard';

@Injectable({
  providedIn: 'root'
})
export class TermsGuard extends AuthGuard {
  constructor(protected store: Store<RootState>) {
    super(store);
  }

  canActivate(): Observable<boolean> {
    this.findSignedInUserIfNeeded();

    return this.store.select(getSignedInUser).pipe(
      filter(it => it != null),
      take(1),
      map(user => {
        let termsAgreed = false;
        const authenticated = user !== 'none';

        if (!authenticated) {
          Log.warn(this.constructor.name, `認証されていません`);
          const url = RoutingPathResolver.resolveSignIn();
          this.store.dispatch(navigate({ url, extras: { replaceUrl: true } }));
        } else {
          if (user !== 'none' && (!user.isTermsAgree || user.isTermsAgree === undefined)) {
            Log.warn(this.constructor.name, `利用規約に同意していません`);
            const url = RoutingPathResolver.resolveTermsAgree();
            this.store.dispatch(navigate({ url, extras: { replaceUrl: true } }));
          } else {
            termsAgreed = true;
          }
        }

        return authenticated && termsAgreed;
      })
    );
  }
}
